import React from 'react'
import { RadioGroup } from '../../components/shared'
import ConvertibleText from '../../components/shared/ConvertibleText'
import Loading from '../../components/shared/Loading'
import ManualRate from './ManualRate'
import classNames from 'classnames'

const baseCoverage = (props) => {
    const { 
        option,
        manuallySetPricing,
        onBlurTextboxHandler,
        isModified: isBusy,
        pricingValues,
        totalCost,
        columnClasses
    } = props

    const isMinimumPremium = pricingValues.rate === '-1'
        || manuallySetPricing === true && pricingValues.basePremium <= pricingValues.oeMinimumPremium 
            ? true 
            : false
    let rate = ''

    if (manuallySetPricing === true && !isMinimumPremium) {
        if (option.selected === 'true' || option.selected === true) {
            if (pricingValues.basePremium < 0) {
                /**
                 * This condition runs just for display purposes in case a user enters a negative
                 * basePremium or negative debit/credit.
                 */
                rate = ((pricingValues.basePremium * 1000) / Number(totalCost)).toFixed(2)
            } else if (pricingValues.manualRate !== undefined && pricingValues.manualRate !== null) {
                // UI only allows 2 decimals, but adding toFixed in case that changes
                rate = Number(pricingValues.manualRate).toFixed(2)
            } else if (Object.hasOwn(pricingValues, 'rate')) {
                rate = Number(pricingValues.rate).toFixed(2)
            } else {
                rate = 0
            }
        } else {
            // calc rate for non-selected base coverages just for display purposes
            rate = ((Number(option.text.replace(/[^0-9.-]+/g,'')) * 1000) / Number(totalCost)).toFixed(2)
        }
    }

    return (
        <div className="coverage-container" key={option.key}>
            <div className="row">
                <div 
                    className={columnClasses.title}
                >
                    <RadioGroup {...props} options={[option]}/>
                </div>
                {isBusy 
                ?   <div className={classNames({
                        'col-sm-offset-5': manuallySetPricing,
                        'col-sm-offset-3': !manuallySetPricing,
                        'col-sm-1': true,
                        'col-xs-10': true
                    })}>
                        <Loading width="23px" height="23px" />
                    </div>
                : <>
                    {manuallySetPricing && <div className={`price-values text-right ${columnClasses.rate}`}>
                        <ManualRate
                            option={option}
                            rate={rate}
                            totalCost={totalCost} 
                            onBlurHandler={onBlurTextboxHandler}
                            disabled={!option.selected || option.disable || isMinimumPremium}
                        />
                    </div>}
                    <div className={`price-values text-right ${columnClasses.premium}`}>
                        <ConvertibleText 
                            manuallySetPricing={manuallySetPricing}
                            disabled={!option.selected || option.disable}
                            value={{name: option.key, text: option.text}}
                            onBlurHandler={onBlurTextboxHandler}
                        />
                    </div>
                </>
                }
            </div>
        </div>
    )
}

export default baseCoverage